import { Link } from '@tanstack/react-router';
import { itemsHref } from '@/routes/items/-search-params';

const BASE_URL = 'https://images.pricedrop.co.il';

interface BrandLinkProps {
  id: number;
  name: string;
}

export default function BrandLink({ id, name }: BrandLinkProps) {
  return (
    <div className="flex flex-col items-center justify-center">
      <Link to={itemsHref({ brands: [id], brandName: name })}>
        <img
          src={`${BASE_URL}/brands/${id}.webp`}
          alt={name}
          className="my-2 h-15 transform rounded px-4 transition duration-900 hover:scale-110 hover:bg-gray-100 dark:bg-gray-200 dark:hover:bg-gray-50"
        />
      </Link>
    </div>
  );
}
